import React, { useState } from 'react'
import { DownOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { Menu, Dropdown } from 'antd'
import { connect } from 'react-redux'
import Cookies from 'js-cookie'
import { actionCreators } from 'store'
import { ACCOUNT_NAME_KEY } from '../../constants'
import EditPassword from './EditPassword'
import { userLogout } from 'request/account'
import './style.scss'

function Header(props) {
  const { menuCollapsed, setMenuCollapsed, setLoginStatus  } = props
  const [isShowEditPassword, setIsShowEditPassword] = useState(false)

  const logout = async() => {
    await userLogout()
    Cookies.remove(ACCOUNT_NAME_KEY, { path: '' })
    setLoginStatus(false)
  }

  const menu = (
    <Menu>
      <Menu.Item>
        <span onClick={() => setIsShowEditPassword(true)}>
          修改密码
        </span>
      </Menu.Item>
      <Menu.Item>
        <span onClick={logout}>
          退出系统
        </span>
      </Menu.Item>
    </Menu>
  )

  return (
    <div className="app-header">
      <div className="collapse" onClick={setMenuCollapsed}>
        {menuCollapsed ? (<MenuUnfoldOutlined/>) : (<MenuFoldOutlined/>)}
      </div>
      <div className="account">
        <Dropdown overlay={menu}>
          <div className="name">{Cookies.get(ACCOUNT_NAME_KEY)} <DownOutlined/></div>
        </Dropdown>
      </div>
      {isShowEditPassword && (
        <EditPassword
          visible={isShowEditPassword}
          close={() => setIsShowEditPassword(false)}
        />
      )}
    </div>
  )
}

export default connect(state => ({
  menuCollapsed: state.getIn(['common', 'menuCollapsed'])
}), dispatch => ({
  setMenuCollapsed() {
    dispatch(actionCreators.setMenuCollapsed())
  },
  setLoginStatus(value) {
    dispatch(actionCreators.setLoginStatus(value))
  }
}))(Header)
